import { render } from "./Contable.vue?vue&type=template&id=6c3e6ea6&scoped=true"
import script from "./Contable.vue?vue&type=script&lang=js"
export * from "./Contable.vue?vue&type=script&lang=js"

import "./Contable.vue?vue&type=style&index=0&id=6c3e6ea6&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3e6ea6"]])

export default __exports__